import TopicTwo from "../../resource-contents/tick-history-contents/TopicTwo";

const TickHistoryContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Unlock Historical Market Intelligence.</h1>
            <p>
              Empower your decisions with reliable tick data from verified
              market feeds.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Accurate Data Feeds</h4>
                </div>
                <p>
                  Every tick is captured and stored with millisecond precision
                  for maximum reliability.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Comprehensive Instrument Coverage</h4>
                </div>
                <p>
                  Explore multiple asset classes across years of historical
                  performance.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Seamless Export Options</h4>
                </div>
                <p>
                  Download tick data in structured formats compatible with your
                  preferred analysis tools.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TickHistoryContentFive;
